// extracted by mini-css-extract-plugin
export default {"headline":"quickLinks_headline__F8sLA"};